import React, { memo, useCallback } from "react";
import { Button } from "@mui/material";
import { ICellRendererParams } from "ag-grid-community";

import { Account } from "fond/types";

interface SwitchAccountCellRendererProps extends ICellRendererParams<Account> {
  onSwitchAccount: (accountId: string, accountName: string) => void;
  currentAccountId?: string;
}

const SwitchAccountCellRenderer: React.FC<SwitchAccountCellRendererProps> = memo(
  ({ data, onSwitchAccount, currentAccountId }: SwitchAccountCellRendererProps) => {
    const isCurrentAccount = data?.ID === currentAccountId;

    const handleClick = useCallback(
      (e: React.MouseEvent) => {
        e.stopPropagation();
        if (data) {
          onSwitchAccount(data.ID, data.Name);
        }
      },
      [data, onSwitchAccount]
    );

    if (!data) return null;

    return (
      <Button
        variant="outlined"
        size="small"
        onClick={handleClick}
        disabled={isCurrentAccount}
        data-testid={`switch-account-button-${data.ID}`}
        sx={{ textTransform: "none" }}
      >
        {isCurrentAccount ? "Current" : "Switch"}
      </Button>
    );
  }
);

SwitchAccountCellRenderer.displayName = "SwitchAccountCellRenderer";

export default SwitchAccountCellRenderer;
